// todoImVorgangAnlegen.ts — „To-do mit Betreff in Vorgang X anlegen" als ein
// Handgriff (T-34, Mail-Picker „Neues To-do…").
//
// Der Picker kennt von einem Vorgang nur die schlanke Zeile, nicht seine
// Slots und Rollen. Deshalb wird der Vorgang einmal geladen und der Entwurf
// genau wie in der V4-Detailseite gebaut: Bezüge aus dem Vorgang, Rollen
// (Hauptverantwortliche, Bearbeiter + Anlegender, zu Informierende) vom
// Vorgang vorbelegt, im persönlichen Vorgang nur der Anlegende.
import { vorgangService } from "../../../services/vorgangService";
import { slotsFromDto } from "../detail/linkSlots";
import { leererTodoEntwurf, todoAnlagePayload } from "../v3/todoEntwurf";

export async function legeTodoImVorgangAn(args: {
    vorgangId: number;
    titel: string;
    currentUserId: string | null;
}): Promise<{ id: number; titel: string }> {
    const titel = (args.titel ?? "").trim();
    if (!titel) throw new Error("Ein neues To-do braucht einen Betreff.");
    const vorgang = await vorgangService.getVorgang(args.vorgangId);
    const entwurf = {
        ...leererTodoEntwurf(slotsFromDto(vorgang), {
            hauptverantwortlich: vorgang.hauptverantwortlich,
            bearbeiter: vorgang.bearbeiter,
            zuInformierende: vorgang.zuInformierende,
            currentUserId: args.currentUserId,
        }),
        titel,
    };
    const angelegt = await vorgangService.createTodo(
        todoAnlagePayload(entwurf, {
            vorgangId: vorgang.id,
            persoenlich: vorgang.persoenlich === true,
            currentUserId: args.currentUserId,
        }) as any,
    );
    return { id: angelegt.id, titel: angelegt.titel || titel };
}
